import { render } from "./SettingsCustomView.vue?vue&type=template&id=aa3bf9ce&ts=true"
import script from "./SettingsCustomView.vue?vue&type=script&lang=ts"
export * from "./SettingsCustomView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__